import { ArrowUp, ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const COLUMNS = [
  {
    title: "HostPoint — In-House",
    links: [
      { label: "HostPoint POS", href: "https://hostpointpos.com/" },
      { label: "HostPoint Retail", href: "https://hostpointretail.com/" },
    ],
  },
  {
    title: "HTI Distribution",
    links: [
      { label: "nebula CRS", href: "https://www.htihospitality.tech/" },
      { label: "nebula PMS", href: "https://www.htihospitality.tech/" },
      { label: "nebula POS", href: "https://www.htihospitality.tech/" },
      { label: "Apex PMS", href: "https://www.htihospitality.tech/" },
      { label: "Plus Point POS", href: "https://www.htihospitality.tech/" },
    ],
  },
  {
    title: "Partners",
    links: [
      { label: "PassportScan", href: "https://www.passportscan.net/" },
      { label: "HTI Hospitality (ZA)", href: "https://www.htihospitality.tech/" },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer-section"
      className="relative bg-[#263562] overflow-hidden"
    >
      <div
        aria-hidden="true"
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[300px] bg-[radial-gradient(ellipse_at_top,rgba(58,176,225,0.15),transparent_65%)]"
      />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="grid lg:grid-cols-[1.2fr_2fr] gap-16 pb-16">
          <div>
            <div className="bg-white rounded-xl px-5 py-4 w-fit shadow-[0_15px_40px_-10px_rgba(0,0,0,0.35)]">
              <img
                src="/assets/hostech-logo.png"
                alt="Hostech Solutions — innovating hospitality"
                className="h-16 w-auto block"
              />
            </div>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-300 font-light">
              Hospitality software engineered and distributed from Nairobi —
              powering hotels, lodges, restaurants and retail across East Africa.
            </p>
            <button
              data-testid="footer-back-to-top"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="mt-8 group flex items-center gap-2 font-mono-tech text-[11px] uppercase tracking-[0.25em] text-slate-300 hover:text-[#3AB0E1] transition-colors"
            >
              <span className="w-8 h-8 rounded-full border border-white/20 flex items-center justify-center group-hover:border-[#3AB0E1] group-hover:-translate-y-0.5 transition-all duration-300">
                <ArrowUp className="w-3.5 h-3.5" />
              </span>
              Back to top
            </button>
          </div>

          <div className="grid sm:grid-cols-3 gap-10">
            {COLUMNS.map((col) => (
              <div key={col.title}>
                <h4 className="font-mono-tech text-[10px] uppercase tracking-[0.3em] text-[#3AB0E1] mb-5">
                  {col.title}
                </h4>
                <ul className="space-y-3">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      <a
                        href={l.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group inline-flex items-center gap-1.5 text-sm text-slate-300 hover:text-white transition-colors"
                      >
                        {l.label}
                        <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div
          aria-hidden="true"
          className="select-none font-display font-extrabold tracking-tight leading-none text-[18vw] lg:text-[13vw] text-white/[0.05] text-center -mb-6 lg:-mb-10"
        >
          HOSTECH
        </div>

        <div className="relative border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 font-mono-tech text-[10px] uppercase tracking-[0.2em] text-slate-400">
          <span>© {new Date().getFullYear()} Hostech Solutions Limited</span>
          <span>Nairobi · Kenya · East Africa</span>
        </div>
      </div>
    </footer>
  );
}
